/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Localized from '../../../shared/components/Localized';
import moment from 'moment';
import { connect } from 'react-redux';

import { TIMESTAMP_FORMAT } from "../../../shared/utils/dates";

function StartTime({
 startTime,
 plannedStartTime,
 ongoing,
 resolved,
 timezone,
 ongoingLabel,
 scheduledLabel,
 format
}) {
  const ongoingLabelKey = ongoingLabel ? ongoingLabel : 'startTime';
  const scheduledLabelKey = scheduledLabel ? scheduledLabel : 'plannedStartTime';
  const timeFormat = format ? format : TIMESTAMP_FORMAT;
  if (ongoing) {
    return (
      <div className='slds-m-bottom--x-small'>
        <div className='slds-text-heading--label-normal'>
          <Localized modelName={'modal'} modelKey={ongoingLabelKey} modelAttribute={'label'} />:&nbsp;
        </div>
        <div>
          { moment.tz(startTime, timezone).format(timeFormat) }
        </div>
        <div className='maintenance-info--planned-time'>
          <span>(</span>
          <span>
            <Localized modelName={'maintenanceModal'} modelKey={scheduledLabelKey} modelAttribute={'label'} />:&nbsp;
            </span>
          <span>
              { moment.tz(plannedStartTime, timezone).format(timeFormat) }
            </span>
          <span>)</span>
        </div>
      </div>
    );
  }

  return (
    <div className='slds-m-bottom--x-small'>
      <div className='slds-text-heading--label-normal'>
        <Localized modelName={'maintenanceModal'} modelKey={scheduledLabelKey} modelAttribute={'label'} />:&nbsp;
      </div>
      <div>
        { moment.tz(plannedStartTime, timezone).format(timeFormat) }
      </div>
    </div>
  );
}

export default connect((state) => ({ timezone: state.timezonePicker }))(StartTime);
